<template>
  <template v-if="oper == 'elecboardofco1head' || oper == 'homeofco1heading'">
    <!-- 一廠打頭 -->
    <machStatusHeading></machStatusHeading>
  </template>
  <template v-else-if="oper == 'elecboardofco1thread' || oper == 'homeofco1thread'">
    <!-- 一廠輾牙 -->
    <machStatusThread></machStatusThread>
  </template>
  <template v-else-if="oper == 'elecboardofco1heat' || oper == 'homeofco1heat'">
    <!-- 一廠熱處理 -->
    <machStatusHeat></machStatusHeat>
  </template>
  <template v-else-if="oper == 'elecboardofco2head' || oper == 'homeofco2heading'">
    <!-- 二廠打頭 -->
    <machStatusHeading></machStatusHeading>
  </template>
  <template v-else-if="oper == 'elecboardofco2thread' || oper == 'homeofco2thread'">
    <!-- 二廠輾牙 -->
    <machStatusThread></machStatusThread>
  </template>
  <template v-else-if="oper == 'elecboardofco2heat' || oper == 'homeofco2heat'">
    <!-- 二廠熱處理 -->
    <machStatusHeat></machStatusHeat>
  </template>
  <template v-else-if="oper == 'elecboardofco2pk' || oper == 'homeofco2pk'">
    <!-- 二廠包裝 -->
    <machStatusPackage></machStatusPackage>
  </template>
  <template v-else-if="oper == 'elecboardofco2cn' || oper == 'homeofco2cn'">
    <!-- 二廠裝櫃 -->
    <machStatusContainer></machStatusContainer>
  </template>
</template>

<script>
import {
  computed,
  inject,
  onMounted,
  onUnmounted,
  provide,
  ref,
  watch,
} from "@vue/runtime-core";
import machStatusHeading from "@/components/machStatus/machStatusHeading.vue";
import machStatusThread from "@/components/machStatus/machStatusThread.vue";
import machStatusHeat from "@/components/machStatus/machStatusHeat.vue";
import machStatusPackage from "@/components/machStatus/machStatusPackage.vue";
import machStatusContainer from "@/components/machStatus/machStatusContainer.vue";
import { useStore } from "vuex";
export default {
  components: {
    machStatusHeading,
    machStatusThread,
    machStatusHeat,
    machStatusPackage,
    machStatusContainer,
  },
  setup() {
    const store = useStore();

    const site = inject("site");
    const siteName = inject("siteName");
    const oper = inject("oper");
    const operName = inject("operName");
    const deviceName = inject("deviceName");
    const detail = inject("detail");

    const machStatusAxios = ref(null);
    const machStatusAxiosSource = ref(null);
    const machStatusAxiosResult = ref(null);
    const firstLoad = ref(true);
    const machStatusData = ref(null);
    const nowTime = ref("-");
    const queryCounter = ref(0);

    const detailTabIndex = ref(0);

    const listData = ref({});

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const timeOutId = computed(
      () => store.getters["commonAlert/get_timeOutId"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const machStatusImportAxios = () => {
      const axios = require("axios");
      machStatusAxios.value = axios;
    };
    const machStatusAxiosCancel = () => {
      const CancelToken = machStatusAxios.value.CancelToken;
      const source = CancelToken.source();
      machStatusAxiosSource.value = source;
    };
    const machStatusAxiosAction = async (params) => {
      await machStatusAxios.value
        .post("/static/php/modules.php", params, {
          cancelToken: machStatusAxiosSource.value.token,
        })
        .then(
          function (response) {
            const result = response.data;
            machStatusAxiosResult.value = result;
          }.bind(this)
        )
        .catch(function (err) {
          console.log(err);
        });
    };

    const setSessionItems = () => {
      sessionStorage.setItem(
        "mes-machStatus-detailTabIndex",
        detailTabIndex.value
      );
    };
    window.addEventListener("beforeunload", setSessionItems);

    const getNowTime = () => {
      let Today = new Date();
      nowTime.value =
        Today.getFullYear() +
        "-" +
        String(Today.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(Today.getDate()).padStart(2, "0") +
        " " +
        String(Today.getHours()).padStart(2, "0") +
        ":" +
        String(Today.getMinutes()).padStart(2, "0") +
        ":" +
        String(Today.getSeconds()).padStart(2, "0");
    };
    const clearTimer = () => {
      var highestIntervalId = setInterval(";");
      for (var i = 0; i < highestIntervalId; i++) {
        if (i == timeOutId.value) {
          continue;
        }
        //清除所有計時資料
        clearInterval(i);
      }
    };
    const getMachineData = () => {
      clearTimer();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "machstatus";
      params["methods"] = "GET";
      params["whichFunction"] = "SelectMachineQuery";
      params["site"] = site.value;
      params["oper"] = oper.value;
      params["operName"] = operName.value;
      params["device_name"] = deviceName.value;
      machStatusAxiosAction(params).then(() => {
        if (firstLoad.value == true) {
          methods.triggerLoadingBar();
          firstLoad.value = false;
        }

        let result = machStatusAxiosResult.value;
        let response = result.Response;
        console.log(result);

        let result_data = result.QueryTableData;
        if (response == "ok") {
          if (site.value != result.QueryData.site) {
            machStatusData.value = null;
            return;
          }
          if (oper.value != result.QueryData.oper) {
            machStatusData.value = null;
            return;
          }
          if (deviceName.value != result.QueryData.device_name) {
            machStatusData.value = null;
            return;
          }
          //稽核模式：離線機台暫時顯示為運作中，其他狀態不受影響
          //機台明細的單機查詢沒有像總覽/看板那樣把空值正規化成"S"，所以空字串也視為離線
          if (result_data[0]["auditMode"]) {
            if (
              result_data[0]["machine_status"] == "S" ||
              !result_data[0]["machine_status"]
            ) {
              result_data[0]["machine_status"] = "R";
            }
            //下方時間軸進度條：無資料(status為null)的區段一併顯示為生產中
            //熱處理明細分「進料/出料」兩條時間軸，欄位名稱跟其他製程不同，三個都要處理
            [
              "stack_bar_information",
              "ht_in_stack_information",
              "ht_out_stack_information",
            ].forEach((key) => {
              const stackBarInformation = result_data[0][key];
              if (!stackBarInformation) {
                return;
              }
              Object.values(stackBarInformation).forEach((segments) => {
                if (!Array.isArray(segments)) {
                  return;
                }
                segments.forEach((segment) => {
                  if (segment.status == null) {
                    segment.status = "生產";
                  }
                });
              });
            });
          }
          machStatusData.value = result_data[0];
        }

        queryCounter.value++;
        getNowTime();
        setTimeout(function () {
          if (detail.value == false) {
            return;
          }
          getMachineData();
        }, 1000);
      });
    };

    // 數值轉換成中文
    const convertToTraditionalChineseNumber = (number) => {
      const chineseNumberMap = {
        0: "零",
        1: "一",
        2: "二",
        3: "三",
        4: "四",
        5: "五",
        6: "六",
        7: "七",
        8: "八",
        9: "九",
      };

      return String(number)
        .split("")
        .map((digit) => chineseNumberMap[digit])
        .join("");
    };

    // 取得溫度曲線圖資料
    const getAreaGroup = (data, areaQty) => {
      let temperatureArray = [];
      let timeArray = [];
      if (data.std_heat_param == null || data.std_heat_param == "") {
        return;
      }
      [temperatureArray, timeArray] = getStdChartValue(data.std_heat_param);

      var areaGroup = [];

      for (let i = 1; i <= areaQty; i++) {
        var area = {
          name: convertToTraditionalChineseNumber(i) + "區",
          chartData: {
            grid: {
              top: "10%",
              left: "3%",
              right: "4%",
              bottom: "5%",
              containLabel: true,
            },
            xAxis: [
              {
                type: "category",
                data: timeArray,
                splitLine: { show: false },
                axisPointer: {
                  type: "shadow",
                },
              },
            ],
            yAxis: {
              type: "value",
              // name: "單位 溫度",
              minInterval: 1,
              scale: true,
            },
            series: [
              // 標準值
              {
                data: temperatureArray,
                type: "line",
                showSymbol: false,
                lineStyle: {
                  color: "#aaaaaa",
                  width: 4,
                },
              },
              // 實際值
              {
                data: [],
                type: "line",
                showSymbol: false,
                lineStyle: {
                  color: "#e78500",
                  width: 4,
                },
              },
            ],
          },
        };
        areaGroup.push(area);
        let key = "temp" + i;
        if (data.act_heat_param.hasOwnProperty(key)) {
          areaGroup[areaGroup.length - 1].chartData.series[1].data =
            Object.values(data.act_heat_param[key]);
          // console.log( Object.values(data.act_heat_param[key]));
        }
      }
      console.log(areaGroup);

      return areaGroup;
    };
    // 取得溫度曲線圖-標準值資料
    const getStdChartValue = (data) => {
      let temperatureArray = [];
      let timeArray = [];
      let currentTemp = 0;
      let currentTime = 0;

      let decimalPlaces = getMaxDecimalPlaces(data);
      data.forEach((item) => {
        let timeSteps = item.hours * Math.pow(10, decimalPlaces);
        let tempIncrementPerStep = 0;

        if (item.status === "K") {
          // 如果是持續類型，直接將溫度添加到數組
          currentTemp = item.temp;
        } else if (item.status === "H") {
          // 如果是移動類型，計算溫度的增量和每小時增加的溫度值
          let tempDiff = item.temp - currentTemp;
          tempIncrementPerStep = tempDiff / timeSteps;
        }

        for (let t = 0; t < timeSteps; t++) {
          currentTemp += tempIncrementPerStep;
          currentTemp = Math.min(currentTemp, item.temp); // 確保不超過目標溫度
          temperatureArray.push(currentTemp);
          currentTime += 1 / Math.pow(10, decimalPlaces);
          timeArray.push(currentTime.toFixed(decimalPlaces));
        }
      });
      return [temperatureArray, timeArray];
    };
    // 取得最長小數點位數
    const getMaxDecimalPlaces = (data) => {
      let maxDecimalPlaces = 0;
      data.forEach((item) => {
        let decimalPlaces = getDecimalPlaces(item.hours);
        if (decimalPlaces > maxDecimalPlaces) {
          maxDecimalPlaces = decimalPlaces;
        }
      });
      return maxDecimalPlaces;
    };
    // 取得小數點位數
    const getDecimalPlaces = (num) => {
      let match = ("" + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
      if (!match) return 0;
      return Math.max(
        0,
        (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0)
      );
    };

    const commonMethods = {
      convertToTraditionalChineseNumber: convertToTraditionalChineseNumber,
      getAreaGroup: getAreaGroup,
    };

    // 紀錄查詢次數，超過1500次重新整理
    watch(queryCounter, (newValue) => {
      if (newValue > 1500) {
        window.location.reload();
      }
    });

    machStatusImportAxios();
    machStatusAxiosCancel();

    onMounted(() => {
      const mesMachStatusDetailTabIndex = sessionStorage.getItem(
        "mes-machStatus-detailTabIndex"
      );

      sessionStorage.removeItem("mes-machStatus-detailTabIndex");

      if (
        mesMachStatusDetailTabIndex != null &&
        mesMachStatusDetailTabIndex != "undefined"
      ) {
        detailTabIndex.value = Number(mesMachStatusDetailTabIndex);
      }
      console.log(detailTabIndex.value);
    });

    if (firstLoad.value == true) {
      methods.triggerLoadingBar();
    }
    getMachineData();

    provide("nowTime", nowTime);
    provide("machStatusData", machStatusData);
    provide("detailTabIndex", detailTabIndex);
    provide("commonMethods", commonMethods);
    provide("listData", listData);

    onUnmounted(() => {
      window.removeEventListener("beforeunload", setSessionItems);
      clearTimer();
    });
    return { site, oper };
  },
};
</script>

<style>
.machStatus-update-time {
  font-size: 1rem;
}
.machStatus-button {
  border: 0px;
  border-radius: 5px;
  background-color: var(--main-bg-color);
  color: var(--main-font-color);
  padding: 0 13px;
  width: 4.25rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 1.125rem;
  font-family: dfyuanstd-w7, dfyuanstd-w5;
  text-align: center;
  margin: 0 0 0 0.5rem;
  cursor: pointer;
}
.machStatus-main-image {
  width: 100%;
  max-height: 8rem;
  object-fit: contain;
}
.machStatus-introduce {
  margin-bottom: 2.3rem;
}
.machStatus-introduce-list {
  line-height: 2rem;
  height: 2rem;
}
.machStatus-status-bar {
  text-align: right;
}
.machStatus-status-color-bar {
  width: 223px;
  display: inline-block;
}
.machStatus-status-color-bar > div > div {
  padding: 0px 13px;
  width: 4.25rem;
  height: 2rem;
  font-size: 1.125rem;
  font-family: dfyuanstd-w7, dfyuanstd-w5;
  text-align: center;
  margin: 0 0 0 0.5rem;
  font-weight: normal;
}
.machStatus-input-group-text {
  background-color: var(--main-bg-color);
  color: var(--main-font-color);
}
.machStatus-input-group > input {
  background-color: #ccc !important;
  border-color: #ccc;
  color: #495057;
}
.machStatus-paragraph {
  margin-top: 1.875rem;
}
.machStatus-paragraph-title {
  text-align: left;
  color: #000;
  font-family: dfyuanstd-w5, dfyuanstd-w3;
  font-size: 1rem;
}
.machStatus-tab-content {
  background-color: #f2f2f2;
}
.machStatus-percent-bar {
  height: 45px;
  margin-top: 1rem;
}
.machStatus-percent-bar-text {
  line-height: 45px;
  font-size: 1.3rem;
  position: absolute;
  width: 100%;
}
@media screen and (max-width: 1400px) {
  .machStatus-status-bar {
    text-align: left;
  }
}
.machStatus-progress-bar-R {
  background-color: var(--main-status-success-color);
}
.machStatus-progress-bar-Q {
  background-color: var(--main-status-warning-color);
}
.machStatus-progress-bar-H {
  background-color: var(--main-status-danger-color);
}
.machStatus-progress-bar-S {
  background-color: var(--main-status-stop-color);
}
.machStatus-progress-bar-A {
  background-color: var(--main-status-shunting-color);
}
.machStatus-progress-bar-C {
  background-color: var(--main-status-shunting-color);
}
.machStatus-progress-bar-D {
  background-color: var(--main-status-shunting-color);
}
.machStatus-progress-bar-I {
  background-color: var(--main-status-short-color);
}
.machStatus-progress-bar-M {
  background-color: var(--main-status-maintain-color);
}
.machStatus-progress-bar-E {
  background-color: var(--main-status-maintain-color);
}
</style>
